module.exports = __webpack_public_path__ + "media/Images/icon-user-page-o-b8db1fb28b602279dc525e360fef48f8.svg";